module.exports = __webpack_public_path__ + "img/Travel, Bags & Luggage.bef4227b.png";